import {Component, OnInit} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {HttpClient} from "@angular/common/http";
import {TaskStatus, TasksV1Service, TaskType} from "../../../apis/backend";
import {firstValueFrom, Observable} from "rxjs";

@Component({
    selector: 'task-type-dialog',
    templateUrl: './task-type-dialog.component.html',
})
export class TaskTypeDialogComponent implements OnInit {
    
    public TaskTypes: TaskType[];
    
    public NewTaskTypeName: string;
    
    constructor(public ActiveModal: NgbActiveModal,
                public HttpService: HttpClient,
                public TaskService: TasksV1Service) {
    }
    
    ngOnInit(): void {
        firstValueFrom(this.TaskService.getTaskTypes())
            .then(taskTypes => this.TaskTypes = taskTypes);
    }
    
    AddTaskType() {
        if (this.NewTaskTypeName) {
            this.TaskTypes.push({
                TaskTypeID: 0,
                Name: this.NewTaskTypeName
            });
            this.NewTaskTypeName = "";
        }
    }

    public Save() {
        firstValueFrom(this.TaskService.syncTaskTypes(this.TaskTypes))
            .then(() => this.ActiveModal.close());
    }

    public Cancel() {
        this.ActiveModal.dismiss();
    }
}